import { setLoading } from './loading';

/**
 * Base URL for the backend API.
 *
 * Set at build time via the env var REACT_APP_API_URL — e.g.
 *   REACT_APP_API_URL=https://my-be.azurewebsites.net
 *
 * Leave unset for local dev against a proxied dev server, in which case
 * calls go to the same origin (relative URLs).
 */
const BACKEND_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const apiFetch = async (url, options = {}, formData = false, load = true) => {
  const token = localStorage.getItem('jwt');

  const headers = formData
    ? {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      }
    : {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      };

  try {
    if (load) setLoading(true);

    const response = await fetch(BACKEND_URL + url, { ...options, headers });

    if (response.status === 401) {
      localStorage.removeItem('jwt');
      window.location.href = '/';
      return Promise.reject(new Error('Unauthorized - Redirecting to homepage'));
    }

    // 204 No Content: nothing to parse.
    if (response.status === 204) {
      return response.ok ? null : Promise.reject(new Error('Request failed'));
    }

    const data = await response.json().catch(() => null);
    return response.ok ? data : Promise.reject(data || new Error('Request failed'));
  } catch (error) {
    console.error('API Fetch Error:', error);
    return Promise.reject(error);
  } finally {
    if (load) setLoading(false);
  }
};
